import React, { Component } from "react";
import auth from "../services/authService";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import queryString from "query-string";

class ResetPassword extends Component {
  state = {
    token: "",
    password: "",
    errors: {}
  };
  schema = {
    password: Joi.string()
      .required()
      .label("Password")
  };
  parseHash() {
    const qs = queryString.parse(this.props.location.search);
    this.setState({ token: qs.hash });
  }

  handleSubmit = async e => {
    e.preventDefault();
    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) return;
    const result = await auth.resetPassword(
      this.state.token,
      this.state.password
    );
    if (result.isOk) {
      this.props.onLogin();
      this.props.history.replace("/");
    } else {
      const errors = {};
      Swal.fire({
        type: "error",
        title: "Oops...",
        text: result.errorMessage
      });
      this.setState({ errors });
    }
  };

  validate = () => {
    const result = Joi.validate(this.state.account, this.schema, {
      abortEarly: false
    });
    if (!result.error) return null;
    const errors = {};
    for (let item of result.error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  handleChange = ({ currentTarget: input }) => {
    this.setState({ password: input.value });
  };
  componentDidMount() {
    this.parseHash();
  }
  render() {
    const { password, errors } = this.state;

    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="card">
              <div className="card-body">
                <form onSubmit={this.handleSubmit}>
                  <h5>Reset Password</h5>
                  {errors.loginResult && (
                    <div className="alert alert-danger">
                      {errors.loginResult}
                    </div>
                  )}
                  <div className="form-group">
                    <label forhtml="exampleInputPassword1">New Password</label>
                    <input
                      name="password"
                      onChange={this.handleChange}
                      value={password}
                      type="password"
                      className="form-control"
                      id="exampleInputPassword1"
                      placeholder="Password"
                      autoComplete="current-password"
                    />
                    {errors.password && (
                      <div className="alert alert-danger">
                        {errors.password}
                      </div>
                    )}
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Set Password
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;
